import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Login from './features/account/Login';
import Dashboard from './pages/Dashboard';
import { getLocalStorage } from './storage/localStorage';

const checkLogin = () => {
  const authorization = getLocalStorage('authorization');
  return !!(authorization?.token ?? authorization?.accessToken);
};

function RequireAuth() {
  if (!checkLogin()) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

function LoginOrRedirect() {
  if (checkLogin()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Login />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LoginOrRedirect />} />
      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
